import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { List, Space, Typography } from 'antd';
import React, { useEffect } from 'react';
import AsyncWrapper from '@/components/AsyncWrapper';
import { requestUserPointLogList, User, UserEndpoint } from '@/models/user';
import { UserPointOperator } from '../../pages/User/PointOperator';
import PosButton from '../PosButton';

export type Props = {
  user: User;
  onUserPointChange: (newPoint: number) => void;
  actionAreaClassName?: string;
};

const PointLogList: React.FC<Props> = ({ user, actionAreaClassName, onUserPointChange }: Props) => {
  const { payload, send: getPointLogs, loading, error } = requestUserPointLogList();

  const request = (page = 1) => {
    getPointLogs({
      url: `${UserEndpoint}/point/log/${user.id}`,
      params: { limit: 3, page },
    }).then();
  };

  useEffect(() => {
    if (user && user.id) {
      request(1);
    }
  }, [user]);

  return (
    <AsyncWrapper loading={loading} error={error} render={!!payload}>
      {() => {
        const list = payload.list;
        const page = payload.page;
        return (
          <>
            <List
              loading={loading}
              itemLayout="horizontal"
              size={'small'}
              loadMore={
                <div className={'align-flex-horizontal-center'} style={{ paddingTop: 15 }}>
                  <PosButton
                    disabled={page.current <= 1}
                    loading={loading}
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      request(page.current - 1);
                    }}>
                    上一页
                  </PosButton>
                  <PosButton
                    disabled={page.current === page.pages}
                    loading={loading}
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                      request(page.current + 1);
                    }}>
                    下一页
                  </PosButton>
                </div>
              }
              dataSource={list}
              renderItem={log => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <Space size={15}>
                        <Typography.Text type={log.num > 0 ? 'danger' : 'success'} strong>
                          {log.num > 0 ? (
                            <>
                              <PlusOutlined /> {Math.abs(log.num)}
                            </>
                          ) : (
                            <>
                              <MinusOutlined /> {Math.abs(log.num)}
                            </>
                          )}
                        </Typography.Text>
                        <Typography.Text type={'secondary'}>{log.addTime}</Typography.Text>
                      </Space>
                    }
                    description={
                      <Space direction={'vertical'} size={5}>
                        <div>{log.comment ? log.comment : log.typeDesc}</div>
                      </Space>
                    }
                  />
                </List.Item>
              )}
            />
            <div className={actionAreaClassName}>
              <UserPointOperator
                user={user}
                onSuccess={newPoint => {
                  request(1);
                  onUserPointChange(newPoint);
                }}
              />
            </div>
          </>
        );
      }}
    </AsyncWrapper>
  );
};

export default PointLogList;
